import useCurrency from "@Currency/hooks/useCurrency";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

export default function useGetPassengerClassPrices() {
    const {val} = useCurrency()
    const getPassengerClassGroupPrice = (passengerClass: AvailablePassengerClassType, passengerIdsGroup: number[]) => {
        const price = passengerClass.prices[passengerIdsGroup.length] * passengerIdsGroup.length
        const displayablePrice = `${price} ${val}`

        return {
            price,
            displayablePrice,
        }
    }

    return {
        getPassengerClassGroupPrice,
    }
}